// extracted by mini-css-extract-plugin
export var body = "styles-module__body___X90IG";
export var desktop = "styles-module__desktop___mW8pY";
export var form = "styles-module__form___JSyEo";
export var left = "styles-module__left___H36nq";
export var mobile = "styles-module__mobile___Et5gy";
export var panel = "styles-module__panel___EXsUI";
export var right = "styles-module__right___KBZMH";
export var topoBackground = "styles-module__topoBackground___XeBRz";